module.exports = __webpack_public_path__ + "img/language.2774a3ba.svg";